import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { isPosPath, openPosInNewTab } from '../../utils/posTab';

const ViewModeToggle = ({ compact }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { role, tenantId, isImpersonating } = useAuth();
  const isPos = isPosPath(location.pathname);

  // Super admins only get salon/POS controls while impersonating a salon.
  const canUseSalonViews =
    role === 'SALON_MANAGER' || (role === 'SUPER_ADMIN' && (isImpersonating || !!tenantId));

  if (!canUseSalonViews) return null;

  return (
    <div
      className={`flex rounded-lg border border-zinc-300 dark:border-zinc-700 p-0.5 ${
        compact ? 'text-xs' : 'text-sm'
      }`}
    >
      <button
        type="button"
        onClick={() => navigate('/salon/dashboard')}
        className={`rounded-md px-2.5 py-1 ${!isPos ? 'bg-glow-600/25 text-glow-300' : 'text-zinc-500'}`}
      >
        {t('pos.viewNormal')}
      </button>
      <button
        type="button"
        onClick={() => !isPos && openPosInNewTab()}
        disabled={isPos}
        title={isPos ? t('pos.alreadyOpen') : t('pos.openInNewTab')}
        className={`rounded-md px-2.5 py-1 ${isPos ? 'bg-glow-600/25 text-glow-300' : 'text-zinc-500 hover:text-zinc-300'}`}
      >
        {t('pos.viewPos')}
      </button>
    </div>
  );
};

export default ViewModeToggle;
